import { GET_MONTHWISE_M2D_DETAIL_REPORT } from '../../../Types';

const initialState = {
    data: [],
    totalRecords: 0
};

const monthWiseM2DDetailReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_MONTHWISE_M2D_DETAIL_REPORT:
            return {
                ...state,
                data: action.payload?.data ?? [],
                totalRecords: action.payload?.totalRecords ?? 0
            };

        default:
            return state;
    }
};

export default monthWiseM2DDetailReportReducer;